import React from 'react'
import { useIntl } from 'react-intl'
import { Chip } from '@arnsbogroup/react-voicearchive'
import messages from './messages'

export { messages as aiFileMessages }

const PROBLEM_STATUSES = ['tagged_unsigned', 'unsupported', 'failed']

/**
 * Marks or unmarks files as AI-generated (EU AI Act Art. 50).
 * Files are grouped by their own task: job files shown on a task page belong to the job.
 *
 * Resolves with the list of error messages (empty when everything was saved).
 */
export const setFilesAi = (files, isAi) => {
  const fileIdsByTask = files.reduce((groups, file) => ({
    ...groups,
    [file.task]: [...(groups[file.task] || []), +file.uid],
  }), {})

  return Promise.all(Object.entries(fileIdsByTask).map(([taskId, fileIds]) =>
    fetch(`/rest/v2/task/${taskId}/file-ai`, {
      method: 'PUT',
      credentials: 'same-origin',
      body: JSON.stringify({ fileIds, isAi }),
    })
      .then((response) => response.json())
      .then(({ errors = [] }) => errors)
  )).then((errorLists) => errorLists.flat())
}

/**
 * "AI" chip for a file row; the tooltip explains how far the disclosure got.
 * Renders nothing for files that are not AI-generated.
 */
const AiFileChip = ({ isai, ai_tag_status: status, className }) => {
  const { formatMessage } = useIntl()

  if (!+isai) {
    return null
  }

  const message = messages[status] || messages.pending
  const isProblem = PROBLEM_STATUSES.includes(status)

  return (
    <Chip
      className={className}
      state={isProblem ? 'error' : 'info'}
      title={formatMessage(message)}
    >
      {isProblem ? 'AI !' : 'AI'}
    </Chip>
  )
}

export default AiFileChip
